import type { MetaDescriptor } from '@remix-run/react';
import { hasProductFilterSearchParams } from '@theprintbar/ui';

/**
 * Route handle for product listing pages (/products, /collections/*).
 * Filtered views skip the root canonical: they're noindexed, and a canonical pointing elsewhere
 * would contradict the noindex.
 */
export const listingHandle = {
	omitCanonical: (location: { search: string }) => hasProductFilterSearchParams(new URLSearchParams(location.search)),
};

/**
 * Filtered or 404 listings are noindexed but still followed, so Google drops them from the
 * index while still passing equity through to product pages.
 */
export function withListingRobots(meta: MetaDescriptor[], { search, noindex }: { search: string; noindex: boolean }) {
	if (!noindex && !hasProductFilterSearchParams(new URLSearchParams(search))) return meta;

	return [
		...meta.filter(descriptor => !('name' in descriptor && descriptor.name === 'robots')),
		{ name: 'robots', content: 'noindex, follow' },
	];
}
